module.exports = __webpack_public_path__ + "img/Rectangle Copy 4@2x.064fcca9.png";